import LessonActivitySwipeCards from "./LessonActivitySwipeCards";

export default LessonActivitySwipeCards